
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home_en",
      function () {
        return require("private-next-pages/home_en.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home_en"])
      });
    }
  